var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupDoctors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "222.601px",
    height: "188.5px",
    viewBox: "13.3 30.5 222.601 188.5",
    enableBackground: "new 13.3 30.5 222.601 188.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "219.4,172.8 209.4,172.8 209.4,162.8 203.2,162.8 203.2,172.8 193.3,172.8 193.3,179 203.2,179  203.2,188.9 209.4,188.9 209.4,179 219.4,179  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M163.4,120.7l-36.7,36.7L90,120.7c-19.7,3.6-34.7,20.899-34.7,41.6V219H198v-56.7 C198.1,141.6,183.1,124.3,163.4,120.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2a8ae5",
    cx: 126.7,
    cy: 71.2,
    r: 40.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "178.1,163.4 166.1,163.4 166.1,151.4 158.6,151.4 158.6,163.4 146.7,163.4 146.7,170.9  158.6,170.9 158.6,182.8 166.1,182.8 166.1,170.9 178.1,170.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M43.3,162.3c0-7,1.4-13.8,3.8-20l-5-5c-16.4,3-28.8,17.4-28.8,34.601V219h30V162.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M207.2,137.3l-2.2,2.2c3.2,7,5,14.8,5,22.9V219h25.9v-47.1C236,154.6,223.6,140.3,207.2,137.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M163.8,108.6l1.8,0.3c11.601,2.1,21.7,7.8,29.301,15.7c9.399-6,15.6-16.5,15.6-28.5 c0-18-14.1-32.8-31.9-33.8c0.5,2.9,0.801,5.8,0.801,8.9C179.4,85.8,173.4,99,163.8,108.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M57.1,126.2c7.8-8.8,18.5-15,30.8-17.3l1.8-0.3C80,99,74,85.8,74,71.2c0-3,0.3-6,0.8-8.8 c-0.7,0-1.4-0.1-2.1-0.1c-18.7,0-33.8,15.1-33.8,33.8C38.8,109.2,46.2,120.5,57.1,126.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDoctors);
export default __webpack_public_path__ + "static/media/group_doctors.b8fbb115a121cd82b8081a453984d8f3.svg";
export { ForwardRef as ReactComponent };